import { documentationActions } from '../../actions/constant';
const { IS_CHECK_DOCUMENT_REFORM } = documentationActions;

const intitialstate: object = {
  isReform: false,
};

export const checkIsReformReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case IS_CHECK_DOCUMENT_REFORM:
      return {
        ...state,
        isReform: action.payload,
      };

    default:
      return state;
  }
};
